<template>
  <app-modal unique="add-admin-announcement" title="Add Announcement">
    <form @submit.prevent="confirmAddAdminAnnouncement">

      <div class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
          Title:
        </label>
        <div class="col col-sm-9">
          <input type="text" id="new-announcement-title"
                 class="form-control form-control-xs"
                 placeholder="Enter Announcement Title Here"
                 v-model="newAdminAnnouncement.title"
          >
        </div>
      </div>

      <div class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
          Message:
        </label>
        <div class="col col-sm-9">
              <textarea type="text" id="new-announcement-message" class="form-control"
                        rows="15" cols="30" style="font-size: 9pt"
                        placeholder="Enter Announcement Message"
                        v-model="newAdminAnnouncement.message"
              >
          </textarea>
        </div>
      </div>

      <div class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
          Date From:
        </label>
        <div class="col col-sm-9">
          <input type="date" id="new-announcement-from" class="form-control form-control-xs"
                 v-model="newAdminAnnouncement.date_from"
          >
        </div>
      </div>

      <div class="form-group form-row mb-2">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
          Date To:
        </label>
        <div class="col col-sm-9">
          <input type="date" id="new-announcement-to" class="form-control form-control-xs"
                 v-model="newAdminAnnouncement.date_to"
          >
        </div>
      </div>
      <div class="form-group form-row mb-2">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="attachment" >
          Attachment:
        </label>
        <div class="col col-sm-9">
          <input v-model="newAdminAnnouncement.attachmentName" type="text" class="form-control form-control-xs" id="attachment"
             placeholder="Attachment Name" aria-label="Attachment Name"
          >
          <input @input="addAttachment" type="file" class="form-control-file">
        </div>
      </div>


      <hr />
      <div class="text-right">
        <button type="submit" class="btn btn-outline-primary btn-sm btn-xs font-weight-bolder" v-if="!guest">
          <i class="fas fa-save mr-1"></i>Save
        </button>
      </div>

    </form>
  </app-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
  name: "AddAdminAnnouncement",

  components: { AppModal },

  mixins: [ vueAppMixin, formMixin, gateMixin ],

  data() {
    return {
      newAdminAnnouncement: {},
      newAdminAnnouncementErrors: {},
    }
  },

  methods: {
    ...mapActions([
        'addAdminAnnouncement',
    ]),

    addAttachment(e) {
      this.newAdminAnnouncement.attachmentFile =  e.target.files[0]
    },

    async confirmAddAdminAnnouncement() {
      if(await this.confirmCreateAlert()) {

        let formData = new FormData();

        // append newAdminAnnouncement data
        let params = {};
        let ObjectData = this.newAdminAnnouncement;
        Object.keys(ObjectData).forEach(key => {
          params[key] = ObjectData[key];
        });

        Object.keys(params).forEach(key => {
          let value = params[key] ? params[key] : '';
          formData.append(key, value);
        });


        let newAdminAnnouncement = await this.addAdminAnnouncement(formData);
        if(newAdminAnnouncement) {
          if(newAdminAnnouncement.errors) {
            this.newAdminAnnouncementErrors = newAdminAnnouncement.errors;
          } else {
            this.successAlert('Admin Announcement Successfully Saved', 'CREATE');
            document.getElementById('close-add-admin-announcement').click();
            this.newAdminAnnouncementErrors = {};
            this.newAdminAnnouncement = {};
          }
        } else {
          this.errorAlert('Admin Announcement Failed to Save', 'CREATE')
        }
      }
    },



  },



}
</script>

<style scoped>

</style>